import type { GetStaticProps, NextPage } from 'next';

import PageService from 'services/PageService/PageService';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import faqsData from 'data/FAQ_English.json';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import StaticPageContent, {
  type StaticPageContentProps,
} from 'data/staticPageContent';
import PageLayout from 'blocks/Layouts/page-layout';

import faqsImage from 'assets/faqs/header-image.webp';

import type { IGenericPage } from 'types/interfaces';
import AccordionList from 'components/accordion-list';

interface FAQProps extends IGenericPage {
  pageContent: StaticPageContentProps;
  faqs: typeof faqsData;
}

const FAQ: NextPage<FAQProps> = ({ globalLayoutProps, faqs, pageContent }) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PageLayout {...pageContent} image={faqsImage}>
        <div className="faq-page-container">
          <AccordionList<typeof faqsData[number]>
            items={faqs}
            getId={item => String(item.id)}
            getTitle={item => item.title}
            getContent={item => item.text}
          />
        </div>
      </PageLayout>
    </GlobalLayout>
  );
};

export default FAQ;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.FAQ,
  });
  const pageContent = StaticPageContent[navigationPaths.FAQ];

  return {
    props: {
      ...genericPageProps,
      pageContent,
      faqs: faqsData,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
